<script setup lang="ts">
import type { GeoFenceVisitWithObjectsLinked } from '~/services/apiClientGps'
import { formatDateForHeader } from '~/utils/dateTimeUtils'

const props = defineProps<{
  visit: GeoFenceVisitWithObjectsLinked
  visitCount?: number
}>()

const dateHeaderText = computed(() => formatDateForHeader(props.visit.arrival))
</script>

<template>
  <div class="date-header">
    <div class="date-header-content">
      <h3 class="date-text">{{ dateHeaderText }}</h3>
    </div>
  </div>
</template>

<style scoped lang="scss">
.date-header {
  @apply bg-gray-300 border-b border-gray-200 px-2 py-2;
  position: sticky;
  top: 0;
  z-index: 10;
}

.date-header-content {
  @apply flex items-center justify-between;
}

.date-text {
  @apply text-sm font-bold text-gray-600 m-0;
}

.visit-count {
  @apply text-sm text-gray-500;
}
</style>
